// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Content__content___VZUKJ {
    overflow: hidden;

    width: 0;
    min-width: 100%;
    height: 0;
    min-height: 100%;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/Content/Content.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;;IAEhB,QAAQ;IACR,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB","sourcesContent":[".content {\n    overflow: hidden;\n\n    width: 0;\n    min-width: 100%;\n    height: 0;\n    min-height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Content__content___VZUKJ`
};
export default ___CSS_LOADER_EXPORT___;
